import { useEffect, useRef, useState } from "react";
import CustomerTable from "../components/CustomerList/CustomerTable";
import Filters from "../components/CustomerList/Filters";
import { Button } from "../components/Elements";
import { NavLink } from "react-router-dom";
import { getNavigationUrl } from "../../common/helpers/navigationHelpers";
import { ApiResponseType } from "../../common/api/apiHelper";
import commonNetwork from "../../common/api/commonNetwork";
import CustomerErpTransferModal, { CustomerErpTransferHandles } from "../components/CustomerList/CustomerErpTransferModal";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { exportExcelHelper } from "../../common/helpers/exportExcelHelper";
import { useSelector } from "react-redux";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";

// Sayfa değiştirildiğinde apiye atılacak isteklerde eski filtreyi saklamak için
const initialValues = {
    customerCode: "",
    customerName: "",
    email: "",
    phone: "",
    city: [],
    district: [],
    isMatchToUser: [],
    tcCodeTaxCode: ""
}

const CustomerList = () => {

    usePermissionCheck(UserOperationTypes["Müşteri Listesi"], "Müşteri İşlemleri izni yok");
    const formFilterRef = useRef<HTMLDivElement | null>(null);
    const resultModalRef = useRef<CustomerErpTransferHandles | any>(null);
    const tableSelectedRows = useRef<any>();

    const [filtersIsOpen, setFiltersIsOpen] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [customerErpTransferModalVisible, setCustomerErpTransferModalVisible] = useState<boolean>(false);
    const [headCells, setHeadCells] = useState<any[]>([]);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);

    const { customerList } = useSelector((state: any) => state.webCustomers);
    const { firmInformations } = useRecoilValue(tenantState);

    // Pagination için filtrede ve tabloda page ve pageSize eşitliğini korumak için
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [filterFormValues, setFilterFormValues] = useState(initialValues);

    const onCustomerTransferWithErp = async () => {
        const paramaters = {}

        setPostLoading(true);

        let result: ApiResponseType;

        try {
            result = await commonNetwork.post("/customer/impor-erp", paramaters);
            setCustomerErpTransferModalVisible(true);
            resultModalRef.current.getResult(result);
        } catch (error) {

        } finally {
            setPostLoading(false);
        }
    }

    const handleHeadCells = (values: any) => {
        setHeadCells(values);
    }

    const exportToExcelClick = async () => {
        setExcelLoading(true);
        try {
            exportExcelHelper(customerList, "customerId", tableSelectedRows, headCells, "Müşteri_Listesi");
        } catch (error) {

        } finally {
            setExcelLoading(false);
        }
    }

    return (
        <div className="w-full">
            <PageTitle title={pageTitleTexts.customerList} />

            <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
                <div className="flex flex-row items-center">
                    <img src={"/icons/musteri-listesi-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Müşteri Listesi
                    </span>
                </div>

                <div className=" flex flex-row justify-end items-center px-2">
                    <Button
                        size="xs"
                        hover="gray"
                        color="gray"
                        callback={() => setFiltersIsOpen(!filtersIsOpen)}
                    >
                        <span className="mr-3">{buttonTexts.filterOpen}</span>
                        <img src="/icons/filter.svg" alt="filter" />
                    </Button>
                </div>
            </div>

            <Filters
                ref={formFilterRef}
                isOpen={filtersIsOpen}
                setFiltersIsOpen={setFiltersIsOpen}
                page={page}
                pageSize={pageSize}
                setFilterFormValues={setFilterFormValues} />
            <div className='flex flex-row-reverse pr-4 space-x-3 space-x-reverse'>
                <NavLink to={getNavigationUrl("/musteri-ekle")}>
                    <Button
                        size="xs"
                        hover="primary"
                        color="primary"
                        callback={() => { }}
                    >
                        <img src="/icons/plus-white.svg" alt="add" />
                        <span className='ml-3 mr-3'>Yeni Müşteri</span>
                    </Button>
                </NavLink>
                <Button
                    size="xs"
                    hover="gray"
                    color="gray"
                    callback={onCustomerTransferWithErp}
                    disabled={firmInformations.isErp && !postLoading ? false : true}
                    loading={postLoading}
                >
                    <img src="/icons/bulk-edit-blue.svg" alt="erpAdd" />
                    <span className='ml-3 mr-3'>{buttonTexts.addWithErp}</span>
                </Button>
                <NavLink to={getNavigationUrl("/musteri-ekle-excel")}>
                    <Button
                        size="xs"
                        hover="gray"
                        color="gray"
                        callback={() => { }}
                    >
                        <img src="/icons/excel-file-blue.svg" alt="exccelAdd" />
                        <span className='ml-3 mr-3'>{buttonTexts.addWithExcel}</span>
                    </Button>
                </NavLink>
                <Button
                    color="gray"
                    hover="gray"
                    size="xs"
                    callback={() => exportToExcelClick()}
                    loading={excelLoading}
                    disabled={excelLoading}
                >
                    <img src="/icons/download-blue.svg" alt="pushToExcel" />
                    <span className='ml-3'>{buttonTexts.exportToExcel}</span>
                </Button>
            </div>
            <CustomerTable
                formFilterRef={formFilterRef}
                tableSelectedRows={tableSelectedRows}
                getHeadCells={handleHeadCells}
                page={page} 
                pageSize={pageSize}
                setPage={setPage}
                setPageSize={setPageSize}
                filterFormValues={filterFormValues} />
            <CustomerErpTransferModal
                ref={resultModalRef}
                statusModalVisible={customerErpTransferModalVisible}
                setStatusModalVisible={setCustomerErpTransferModalVisible}></CustomerErpTransferModal>
        </div>
    );
}
export default CustomerList;